/* eslint-disable react-hooks/exhaustive-deps */
import IconButton from 'apollo-react/components/IconButton';
import TextField from 'apollo-react/components/TextField';
import ChevronDown from 'apollo-react-icons/ChevronDown';
import ChevronRight from 'apollo-react-icons/ChevronRight';
import Trash from 'apollo-react-icons/Trash';
import React, { useEffect, useState } from 'react';

const CustomCell = ({ row, column: { accessor } }) => {
  const { id, toggleRow, editRow, expanded, currentAccessor } = row;
  const isExpanded = expanded && currentAccessor === accessor;

  const [value, setValue] = useState(row[accessor]);

  useEffect(() => {
    setValue(row[accessor]);
  }, [row[accessor]]);

  return (
    <TextField
      size="small"
      fullWidth
      value={value}
      icon={
        isExpanded ? <ChevronDown fontSize="extraSmall" /> : <ChevronRight fontSize="extraSmall" />
      }
      iconProps={{
        onClick: () => toggleRow(id, accessor),
        size: 'small',
      }}
      onChange={({ target }) => setValue(target.value)}
      onBlur={() => editRow(id, accessor, value)}
      inputProps={{ style: { borderColor: isExpanded ? 'blue' : '' } }}
    />
  );
};

const ActionCell = ({ row: { id, deleteRow } }) => (
  <IconButton onClick={() => deleteRow(id)}>
    <Trash />
  </IconButton>
);

export const columns = [
  {
    header: 'Label',
    accessor: 'label',
    customCell: CustomCell,
  },
  {
    header: 'Value',
    accessor: 'value',
    customCell: CustomCell,
  },
  {
    accessor: 'action',
    customCell: ActionCell,
    align: 'right',
  },
];
